<template>
  <div class="fj-warp d-f fd-c jc-sb bgc-fff fs-18 ff-roboto">
    <nuxt />
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    created() {},
    mounted() {},
    methods: {}
  }
</script>

<style scoped lang="scss"></style>
